module.exports = __webpack_public_path__ + "img/icon2.8fe4256b.png";